import React from 'react';
import { Link } from 'react-router-dom';

const KeyMetrics: React.FC = () => {
  return (
    <div className="container-fluid key-matrix bg-light py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-5 wow fadeInLeft" data-wow-delay="0.2s">
            <div>
              <h4 className="text-primary">Key Metrics</h4>
              <h1 className="display-4 mb-4">Experience. Impact. Scale. Trust. Innovation.</h1>

              <ul className="nav">
                <li className="nav-item bg-white mb-4 w-100">
                  <Link className="d-flex align-items-center h4 mb-0 p-3 active" data-bs-toggle="pill"
                    to="#ProjectsTab-1">
                    <div className="projects-icon btn-md-square bg-primary text-white me-3"><span
                      className="fas fa-bolt small"></span></div><span>25+ Years of Industry
                        Expertise</span>
                  </Link>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <Link className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill"
                    to="#ProjectsTab-2">
                    <div className="projects-icon btn-md-square bg-primary text-white me-3"><span
                      className="fas fa-charging-station small"></span></div><span>500+ Projects
                        Completed</span>
                  </Link>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <Link className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill"
                    to="#ProjectsTab-3">
                    <div className="projects-icon btn-md-square bg-primary text-white me-3"><span
                      className="fas fa-broadcast-tower small"></span></div><span>50+ Industries
                        Served</span>
                  </Link>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <Link className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill"
                    to="#ProjectsTab-4">
                    <div className="projects-icon btn-md-square bg-primary text-white me-3"><span
                      className="fas fa-bolt small"></span></div><span>300 Million Liters Treated
                        Daily</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-7 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-content">
              <div id="ProjectsTab-1" className="tab-pane fade show p-0 active">
                <div className="projects-item">
                  <img src="img/industrial-1.jpg" className="img-fluid w-100" alt="" />
                  <div className="projects-content bg-white p-4">
                    <h4 className="mb-3">25+ Years of Industry Expertise</h4>
                    <p className="mb-4">We've been at the forefront of water treatment technology and have
                      helped industries navigate challenges for over two & a half decades.
                      Our experience ensures that we deliver solutions that are not only effective but
                      also
                      sustainable and innovative.
                    </p>
                    <Link className="btn btn-primary py-2 px-4" to="/about">Read More</Link>
                  </div>
                </div>
              </div>
              <div id="ProjectsTab-2" className="tab-pane fade show p-0">
                <div className="projects-item">
                  <img src="img/industrial-2.jpg" className="img-fluid w-100" alt="" />
                  <div className="projects-content bg-white p-4">
                    <h4 className="mb-3">500+ Projects Completed</h4>
                    <p className="mb-4">From industrial water treatment plants to municipal treatment
                      plants, we've successfully implemented water treatment systems across diverse
                      sectors.
                      Our portfolio showcases our ability to handle complex projects with precision
                      and efficiency.

                    </p>
                    <Link className="btn btn-primary py-2 px-4" to="inner-page-template.html">Read More</Link>
                  </div>
                </div>
              </div>
              <div id="ProjectsTab-3" className="tab-pane fade show p-0">
                <div className="projects-item">
                  <img src="img/commercial-1.jpg" className="img-fluid w-100" alt="" />
                  <div className="projects-content bg-white p-4">
                    <h4 className="mb-3">100+ Industries Served</h4>
                    <p className="mb-4">Cement, textiles, power, distilleries, automotive—our solutions are
                      trusted across multiple sectors. Our repeat customers contributes immensely in
                      revenues showing long-term trust.
                      We understand the unique challenges of each industry and tailor our solutions to
                      meet specific needs, ensuring optimal performance and compliance with
                      environmental standards.
                    </p>
                    <Link className="btn btn-primary py-2 px-4" to="inner-page-template.html">Read More</Link>
                  </div>
                </div>
              </div>
              <div id="ProjectsTab-4" className="tab-pane fade show p-0">
                <div className="projects-item">
                  <img src="img/commercial-2.jpg" className="img-fluid w-100" alt="" />
                  <div className="projects-content bg-white p-4">
                    <h4 className="mb-4">300 Million Liters Treated Daily</h4>
                    <p className="mb-4">Our systems and operations treat over 300 million liters of water
                      every day, helping industries and municipalities maximize their efficiency and
                      water conservation efforts.
                      We are committed to sustainable practices that not only meet current needs but
                      also preserve resources for future generations.
                    </p>
                    <Link className="btn btn-primary py-2 px-4" to="inner-page-template.html">Read More</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyMetrics;
